import LoginFormModal from '@/components/LoginFormModal';
import VerifySnModal from './VerifySnModal';
import AddressModal from './AddressModal';
import MysteryBoxModal from './MysteryBoxModal';
import MyMysteryBoxModal from './MyMysteryBoxModal';
import SnAlreadyRedeemedModal from './SnAlreadyRedeemedModal';
import type { ServiceRenewalFlow } from '../hooks/useServiceRenewalFlow';
import type { MysteryBoxGift, MyMysteryBoxItem, MyMysteryBoxPagination } from '../hooks/types';

// ─── Dev Only: 各弹窗 mock 数据，避免空 props 导致样式无法预览 ────────────────────
const DEV_MOCK_PRIZES: MysteryBoxGift[] = [
    { id: 1, name: '10% Off Coupon', type: 1, amount: 10 },
    { id: 2, name: '$50 Gift Card', type: 3, amount: 50 },
    { id: 3, name: '$50 Gift Card Gift Card Gift Card', type: 2, amount: 50 },
    { id: 4, name: '$50 Gift Card', type: 3, amount: 50 },
];

const DEV_MOCK_MY_BOX_LIST: MyMysteryBoxItem[] = [
    {
        id: 1,
        sn: 'SN123456789',
        workOrderId: 'WO-20260409-001',
        boxStatus: 1,
        createTime: '2026-04-09 10:00:00',
        ruleGiftRespVos: [{ id: 1, name: '20% Off Coupon', type: 1, amount: 10 }],
        sort: 1,
    },
    {
        id: 2,
        sn: 'SN987654321',
        workOrderId: 'WO-20260408-002',
        boxStatus: 3,
        createTime: '2026-04-08 15:30:00',
        ruleGiftRespVos: [{ id: 2, name: '$50 Gift Card', type: 3, amount: 50 }],
        sort: 2,
    },
];

const DEV_MOCK_MY_BOX_PAGINATION: MyMysteryBoxPagination = { page: 1, size: 10, total: 2, hasNext: false };

interface ModalOrchestratorProps {
    flow: ServiceRenewalFlow;
}

const ModalOrchestrator: React.FC<ModalOrchestratorProps> = ({ flow }) => {
    const {
        activeModal,
        closeModal,
        handleLoginSuccess,
        handleSnVerified,
        handleAddressSubmitted,
        handleOpenMysteryBox,
        handleMyMysteryBox,
        snVerification,
        addressSubmit,
        myMysteryBox,
        locale,
    } = flow;

    const isDev = process.env.NODE_ENV !== 'production';

    const prizes = isDev && addressSubmit.prizes.length === 0 ? DEV_MOCK_PRIZES : addressSubmit.prizes;
    const boxRuleName = isDev && !addressSubmit.boxRuleName ? 'Premium Trade-In Mystery Box' : addressSubmit.boxRuleName;
    const myBoxList = isDev && (!myMysteryBox.list || myMysteryBox.list.length === 0) ? DEV_MOCK_MY_BOX_LIST : myMysteryBox.list;
    const myBoxPagination = isDev && !myMysteryBox.pagination ? DEV_MOCK_MY_BOX_PAGINATION : myMysteryBox.pagination;

    return (
        <>
            <LoginFormModal visible={activeModal === 'login'} onCancel={closeModal} onSuccess={handleLoginSuccess} type="passwordless" />
            <VerifySnModal
                open={activeModal === 'verifySn'}
                locale={locale}
                onCancel={closeModal}
                onSuccess={handleSnVerified}
                loading={snVerification.loading}
                error={snVerification.error}
            />
            <AddressModal
                open={activeModal === 'address'}
                locale={locale}
                onCancel={closeModal}
                onSuccess={handleAddressSubmitted}
                loading={addressSubmit.loading}
                error={addressSubmit.error}
            />
            <MysteryBoxModal
                open={activeModal === 'mysteryBox'}
                onCancel={closeModal}
                onSubmit={handleOpenMysteryBox}
                submitLoading={addressSubmit.loading}
                submitError={addressSubmit.error}
                prizes={prizes}
                boxRuleName={boxRuleName}
            />
            <MyMysteryBoxModal
                open={activeModal === 'myMysteryBox'}
                onCancel={closeModal}
                list={myBoxList}
                loading={myMysteryBox.loading}
                pagination={myBoxPagination}
                onLoadMore={() => myMysteryBox.loadMore(locale)}
            />
            <SnAlreadyRedeemedModal open={activeModal === 'snAlreadyRedeemed'} onCancel={closeModal} onViewMyMysteryBox={handleMyMysteryBox} />
        </>
    );
};

export default ModalOrchestrator;
